import { t } from 'i18next'

export const PLUGIN_SETS = {
  ESSENTIAL: [
    'advlist',
    'autolink',
    'lists',
    'link',
    'charmap',
    'preview',
    'searchreplace',
    'visualblocks',
    'code',
    'media',
    'wordcount',
  ],
  FORMATTING: ['advlist', 'autolink', 'lists', 'link', 'charmap'],

  WITH_SHORTCODES: [
    'advlist',
    'autolink',
    'lists',
    'link',
    'charmap',
    'preview',
    'searchreplace',
    'code',
    'media',
    'wordcount',
  ],
  URL_ONLY: [
    'advlist',
    'autolink',
    'lists',
    'link',
    'charmap',
    'preview',
    'searchreplace',
    'code',
    'help',
    'wordcount',
  ],
}

export const TOOLBAR_SETS = {
  ESSENTIAL:
    'blocks | bold italic underline | alignleft aligncenter alignright | bullist numlist | link | shortcodes',
  FORMATTING:
    ' undo redo | blocks | bold italic underline | alignleft aligncenter alignright | bullist numlist | link | shortcodes',
  WITH_SHORTCODES:
    'undo redo | blocks | bold italic underline | alignleft aligncenter alignright | ' +
    'bullist numlist | link image | shortcodes',
  MOBILE_ESSENTIAL: 'bold italic | bullist numlist | link',
  MOBILE_WITH_SHORTCODES: 'bold italic | bullist numlist | link | shortcodes',
}

export const SHORT_CODES_LIST = [
  '<AGREEMENT_CONTENT>',
  '<AGREEMENT_ID>',
  '<AMOUNT>',
  '<AndroidAppDownload>',
  '<ASSESSMENT_NAME>',
  '<AUTO_RENEW>',
  '<AUTO_RENEW_PACKAGE>',
  '<BILLING_CYCLE>',
  '<BILLING_PERIOD>',
  '<BUSINESS_EMAIL>',
  '<BUSINESS_LINK>',
  '<BUSINESS_LOGO>',
  '<BUSINESS_NAME>',
  '<BUSINESS_PHONE>',
  '<BUSINESS_WEBSITE>',
  '<CLIENT_ADDRESS>',
  '<CLIENT_DOB>',
  '<CLIENT_EMAIL>',
  '<CLIENT_FIRST_NAME>',
  '<CLIENT_GENDER>',
  '<CLIENT_ID>',
  '<CLIENT_LAST_NAME>',
  '<CLIENT_NAME>',
  '<CLIENT_PHONE>',
  '<CORPORATE_NAME>',
  '<CREDITS>',
  '<CURRENCY_SYMBOL>',
  '<Dashboard>',
  '<DATE>',
  '<DAYS_OF_WEEK>',
  '<DISCOUNTED_AMOUNT>',
  '<EMERGENCY_CONTACT_EMAIL>',
  '<EMERGENCY_CONTACT_NAME>',
  '<EMERGENCY_CONTACT_PHONE>',
  '<END_DATE>',
  '<END_TIME>',
  '<EXP_DATE>',
  '<FEEDBACK_LINK>',
  '<FIRST_BILLING_DATE>',
  '<FIRST_CREDIT_ALLOCATION_DATE>',
  '<FIRST_SECONDARY_FEE_BILLING_DATE>',
  '<FIRST_VISIT_DATE>',
  '<FIRST_VISIT_INSTRUCTOR>',
  '<FIRST_VISIT_SESSION_NAME>',
  '<FROM_EMAIL>',
  '<FROM_NAME>',
  '<GENERIC_APP_CLIENT_NAME>',
  '<GIFT_CARD_DESIGN>',
  '<GIFT_CARD_NAME>',
  '<GIFT_CARD_NUMBER>',
  '<GIFT_CARD_RECEIPT>',
  '<GIFT_CARD_VALUE>',
  '<INITIAL>',
  '<INSTRUCTOR>',
  '<INVOICE_AMOUNT>',
  '<INVOICE_LINK>',
  '<INVOICE_NUMBER>',
  '<LINK_TO_AGREEMENT>',
  '<LOCAL_TIME>',
  '<LOCATION>',
  '<LOCATION_ADDRESS>',
  '<LOGIN_LINK>',
  '<LOGIN_URL>',
  '<MASTER_ADMIN_FIRST_NAME>',
  '<MEMBERSHIP_CANCELLATION_CHARGE>',
  '<MEMBERSHIP_LENGTH>',
  '<MEMBERSHIP_NAME>',
  '<MINIMUM_CANCELLATION_TERM>',
  '<NEW_INSTRUCTOR_NAME>',
  '<OLD_INSTRUCTOR_NAME>',
  '<PACKAGE_DESCRIPTION>',
  '<PACKAGE_NAME>',
  '<Packages>',
  '<PASSWORD>',
  '<PAYMENT_DATE>',
  '<PAYMENT_DESCRIPTION>',
  '<PAYMENT_FAILURE_REASON>',
  '<PAYMENT_FREQUENCY>',
  '<PERSONAL_MESSAGE>',
  '<RECURRING_TYPE>',
  '<REMAINING_CREDITS>',
  '<RESERVATION_DATES>',
  '<RESET_PASSWORD_LINK>',
  '<RESOURCE_NUMBER>',
  '<SALESPERSON>',
  '<SALES_TAX>',
  '<SECONDARY_FEE_AMOUNT>',
  '<SECONDARY_FEE_BILLING_CYCLE>',
  '<SESSION_MESSAGE>',
  '<SESSION_NAME>',
  '<SESSION_SERIES>',
  '<SESSION_TYPE>',
  '<SETUP_FEE>',
  '<SHARED_BUSINESS_LOCATIONS>',
  '<SIGNATURE>',
  '<SIGN_UP_LINK>',
  '<SITE_ADDRESS>',
  '<STAFF_ACTION_FIRST_NAME>',
  '<START_DATE>',
  '<START_TIME>',
  '<SUSPEND_END>',
  '<SUSPEND_START>',
  '<TO_NAME>',
  '<TODAY_DATE>',
  '<TOTAL_CART_AMOUNT>',
  '<VISIT_TYPE>',
  '<WAITLIST_LINK>',
  '<Workshops>',
  '<ZOOM_JOIN_URL>',
]

export const AGREEMENT_SHORT_CODES = [
  '<AGREEMENT_ID>',
  '<AMOUNT>',
  '<AUTO_RENEW>',
  '<AUTO_RENEW_PACKAGE>',
  '<BILLING_CYCLE>',
  '<BUSINESS_EMAIL>',
  '<BUSINESS_LOGO>',
  '<BUSINESS_NAME>',
  '<BUSINESS_PHONE>',
  '<CLIENT_ADDRESS>',
  '<CLIENT_DOB>',
  '<CLIENT_EMAIL>',
  '<CLIENT_FIRST_NAME>',
  '<CLIENT_GENDER>',
  '<CLIENT_LAST_NAME>',
  '<CLIENT_NAME>',
  '<CLIENT_PHONE>',
  '<CREDITS>',
  '<CURRENCY_SYMBOL>',
  '<DISCOUNTED_AMOUNT>',
  '<EXP_DATE>',
  '<FIRST_BILLING_DATE>',
  '<FIRST_CREDIT_ALLOCATION_DATE>',
  '<FIRST_SECONDARY_FEE_BILLING_DATE>',
  '<INITIAL>',
  '<LOCAL_TIME>',
  '<MEMBERSHIP_CANCELLATION_CHARGE>',
  '<MEMBERSHIP_LENGTH>',
  '<MINIMUM_CANCELLATION_TERM>',
  '<PACKAGE_DESCRIPTION>',
  '<PACKAGE_NAME>',
  '<SALES_TAX>',
  '<SALESPERSON>',
  '<SECONDARY_FEE_AMOUNT>',
  '<SECONDARY_FEE_BILLING_CYCLE>',
  '<SETUP_FEE>',
  '<SHARED_BUSINESS_LOCATIONS>',
  '<SIGNATURE>',
  '<SITE_ADDRESS>',
  '<TODAY_DATE>',
]

export const SHORT_CODE_OPTIONS = SHORT_CODES_LIST.map((code) => ({
  label: code,
  value: code,
}))

export const UI_STRINGS = {
  API_KEY: import.meta.env.VITE_TINYMCE_API_KEY || import.meta.env.REACT_APP_TINYMCE_API_KEY,
  MOBILE_TOOLBAR: 'shortcodes | undo redo | bold italic underline | link | bullist numlist',
  DEFAULT_MENUBAR: 'file edit view insert format tools',
}

export const MENU_CONFIG = {
  view: { title: 'View', items: 'code preview' },
  edit: { title: 'Edit', items: 'undo redo | selectall' },
}

export const VALID_TAGS = {
  ALLOWED_TAGS: [
    'div',
    'p',
    'br',
    'strong',
    'em',
    'u',
    'ul',
    'ol',
    'li',
    'a',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'span',
    'pre',
    'code',
  ],
  VALID_ELEMENTS: `
            a[href|target|title|style],
            img[src|alt|width|height|style|align|title],
            table[style|width|border|cellspacing|cellpadding|align],
            tbody,thead,tfoot,
            tr[style],
            td[style|colspan|rowspan|align|valign|width|height],
            th[style|colspan|rowspan|align|valign|width|height],
            p[style|class],
            br,
            hr[style],
            span[style|class],
            div[style|class|align],
            strong/b,em/i,u,
            h1,h2,h3,h4,h5,h6,
            ul,ol,li
          `,
  EXTENDED_VALID_ELEMENTS: 'table[*],tr[*],td[*],th[*],img[*],a[*],div[*],span[*]',
}
